let cachedBackend: boolean | null = null;

/** True when Pages Functions + D1/R2 are reachable (wrangler pages dev or production). */
export async function apiBackendAvailable(): Promise<boolean> {
  if (cachedBackend !== null) return cachedBackend;
  try {
    const response = await fetch("/api/health", { headers: apiHealthHeaders() });
    if (!response.ok) {
      cachedBackend = false;
      return false;
    }
    const body = (await response.json()) as { ok?: boolean; storage?: string };
    cachedBackend = Boolean(body.ok);
    return cachedBackend;
  } catch {
    cachedBackend = false;
    return false;
  }
}

export function resetBackendCache(): void {
  cachedBackend = null;
}

function apiHealthHeaders(): HeadersInit {
  const headers: Record<string, string> = {};
  const devEmail = import.meta.env.VITE_DEV_USER_EMAIL as string | undefined;
  if (import.meta.env.DEV && devEmail) headers["x-user-email"] = devEmail;
  return headers;
}
